import { render, staticRenderFns } from "./InvitationSuccess.vue?vue&type=template&id=3bb3fa6d&scoped=true&"
import script from "./InvitationSuccess.vue?vue&type=script&lang=js&"
export * from "./InvitationSuccess.vue?vue&type=script&lang=js&"
import style0 from "./InvitationSuccess.vue?vue&type=style&index=0&id=3bb3fa6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb3fa6d",
  null
  
)

export default component.exports